import {Stack, Typography} from '@mui/material';
import {useBeneficiaryCard} from 'presentation/hooks';
import {ReviewCard} from 'presentation/pages/private/booking/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {formatText, getUserInfoFromToken} from 'presentation/utils';
import React from 'react';

const {beneficiaryPlan, cardCode} = translations['pt-br'].commons;
const {beneficiaryData} = translations['pt-br'].privateFlow.bookingFlow;

export const RequestScheduleBeneficiaryData = () => {
	const {isDesktop} = useMediaQueries();

	const {beneficiaryCardPlanData} = useBeneficiaryCard();
	const {cdUsuario} = getUserInfoFromToken();

	return (
		<Stack gap={2}>
			{isDesktop ? (
				<Typography variant="subtitle2" color="text.secondary">
					{beneficiaryData}
				</Typography>
			) : null}
			<ReviewCard.Root>
				<ReviewCard.Header subheader={beneficiaryPlan} />
				<Stack gap={2}>
					<ReviewCard.Content
						iconName={'account-circle-filled'}
						primaryText={formatText(beneficiaryCardPlanData?.userName)}
					/>
					<ReviewCard.Content
						iconName={'hapvida-logo'}
						primaryText={formatText(beneficiaryCardPlanData?.planName)}
						secondaryText={`${cardCode}: ${cdUsuario}`}
						secondaryTextColor="text.secondary"
					/>
				</Stack>
			</ReviewCard.Root>
		</Stack>
	);
};
